import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const SessionWarningDialog = ({
  remainingTime,
  onExtendSession,
  onLogout,
  isVisible,
}) => {
  return (
    <Dialog
      open={isVisible}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle>Session Expiring Soon</DialogTitle>

      <DialogContent>
        <Typography>
          Your session will expire in 5 minutes. Would you like to extend your
          session?
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2.5, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={onLogout}
          sx={{
            color: "grey.700",
            borderColor: "grey.400",
            "&:hover": {
              borderColor: "grey.600",
              backgroundColor: "grey.50",
            },
          }}
        >
          Logout
        </Button>
        <Button
          variant="contained"
          onClick={onExtendSession}
          sx={{
            backgroundColor: "#00AB4E",
            "&:hover": {
              backgroundColor: "#008C40",
            },
          }}
        >
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionWarningDialog;
